export default __webpack_public_path__ + "static/media/2_0028.9338184b.webp";